import { useState, useCallback } from 'react';

export interface CostLedger {
  lastRunUsd: number;
  sessionUsd: number;
  record: (usd: number) => void;
  reset: () => void;
}

export function useCostLedger(): CostLedger {
  const [lastRunUsd, setLastRunUsd] = useState(0);
  const [sessionUsd, setSessionUsd] = useState(0);

  const record = useCallback((usd: number) => {
    if (!usd || usd <= 0 || !Number.isFinite(usd)) return;
    setLastRunUsd(usd);
    setSessionUsd((prev) => prev + usd);
  }, []);

  const reset = useCallback(() => {
    setLastRunUsd(0);
    setSessionUsd(0);
  }, []);

  return { lastRunUsd, sessionUsd, record, reset };
}

export function parseCostHeader(headers: Headers): number {
  const raw = headers.get('X-Request-Cost-Usd') || headers.get('x-request-cost-usd');
  if (!raw) return 0;
  const n = parseFloat(raw);
  return Number.isFinite(n) ? n : 0;
}
